import { Dialog, DialogTitle } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 0,
        backgroundColor: "var(--white)",
        width: "100%",
        height: "calc(100% - 40px)",
        maxWidth: "none",
        maxHeight: "none",
        margin: 20,
        boxShadow: "none"
    },
    "& .MuiBackdrop-root": {
        backgroundColor: "rgba(0, 0, 0, 0.40)"
    }
}));

export function Popup({ mobilePopup, setMobilePopup, children, id, title }) {
    return (
        <CustomDialog
            onClose={() => setMobilePopup(null)}
            open={mobilePopup === id}
        >
            <div onClick={() => setMobilePopup(null)} className="bigX"></div>
            <h2 style={{ padding: "0 20px", height: "56px", fontSize: "20px", lineHeight: "75px" }}>{title}</h2>
            <div style={{ padding: "20px", flex: 1, overflowY:"auto" }}>
                {children}
            </div>
        </CustomDialog>
    )
}